<template>
<!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-data-table
              :headers="headers"
              :items="creationRequests"
              :pagination.sync="pagination"
              :total-items="totalCreationRequests"
              :loading="loading"
              class="elevation-1"
            >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.merchantId }}</td>
              <td>{{ props.item.makerUsername }}</td>
              <td>{{ props.item.makerComment }}</td>
              <td>{{ props.item.requestType }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td>
                <v-btn v-if="props.item.approved === 1" small color="primary"> APPROVED</v-btn>
                <v-btn v-if="props.item.approved === 0" small color="secondary"> NOT YET APPROVED</v-btn>
                <v-btn v-if="props.item.approved === 2" small color="warning"> REJECTED </v-btn>
              </td>
              <td>{{ props.item.checkerUsername }}</td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'merchantrequests',
  data: function() {
    return {
      headers: [
        {
          text: 'Merchant Name',
          value: 'name'
        },
        { text: 'Merchant Id', value: 'merchantId' },
        { text: 'Maker Username', value: 'makerUsername' },
        { text: 'Maker Comment', value: 'makerComment' },
        { text: 'Request Type', value: 'requestType' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Approved', value: 'approved' },
        { text: 'Approved By', value: 'checkerUsername' }
      ],
      creationRequests: [],
      loading: true,
      pagination: {},
      totalCreationRequests: 0
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getMyMerchantCreationRequests()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getMyMerchantCreationRequests () {
      var url = config.serverURI + '/merchant/creationrequests'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.creationRequests = response.data
            this.totalCreationRequests = this.creationRequests.total
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.creationRequests
    }
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// merchantrequests.vue?7eefeee4